export const preferredTheme = 'preferred_theme';
